export function pluralize(number: number, item: string, es?: boolean) {
  return `${number} ${pluralizeWord(number, item, es)}`;
}

export function pluralizeWord(number: number, item: string, es?: boolean) {
  return `${item}${number === 1 ? "" : es ? "es" : "s"}`;
}
